export const DEMO_FORM_REQUEST = 'DEMO_FORM_REQUEST'
export const DEMO_FORM_SUCCESS = 'DEMO_FORM_SUCCESS'
export const DEMO_FORM_ERROR = 'DEMO_FORM_ERROR'
export const SET_COMPANY = 'SET_COMPANY'
export const SET_NAME = 'SET_NAME'
export const SET_EMAIL = 'SET_EMAIL'
export const SET_PHONE = 'SET_PHONE'



// WEBPACK FOOTER //
// ./src/store/modules/demoForm/types.js